<template>
  <div class="w-full flex p-3 justify-center">
    <div class="w-full">
      <div class="vx-row m-0 w-full text-left flex">
        <div class="vx-col font-bold p-2 flex-1 basis-1/12">Nº da Cotação</div>
        <div class="vx-col font-bold p-2 flex-1 basis-2/12">
          Data da Cotação
        </div>
        <div class="vx-col font-bold p-2 flex-1 basis-1/12">
          Tipo de cotação
        </div>
        <div class="vx-col font-bold p-2 flex-1 basis-4/12">Segurado</div>
        <div class="vx-col font-bold p-2 flex-1 basis-3/12">Veículo</div>
        <div class="vx-col font-bold p-2 flex-1 basis-1/12">Corretora</div>
      </div>
      <ul>
        <li v-for="item in cotacoes" :key="item.id_proposta">
          <div class="vx-row m-0 w-full text-left flex">
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              <a
                style="color: inherit"
                target="_blank"
                :href="getDetailsUrl(item)"
                class="cursor-pointer flex items-center justify-between w-4/12"
              >
                <div class="mr-2">
                  {{ item.id_proposta }}
                </div>
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-external-link"
                ></vs-icon>
              </a>
            </div>
            <div class="vx-col p-2 flex-1 basis-2/12 flex items-center">
              {{
                functions.formataDataHoraPadraoBR(
                  item.proposal_createdAt,
                  false,
                )
              }}
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{
                isEndorsement(item)
                  ? QUOTATION_TYPE.ENDORSEMENT
                  : QUOTATION_TYPE.NEW
              }}
            </div>
            <div class="vx-col p-2 flex-1 basis-4/12 flex items-center">
              <a
                target="_blank"
                style="color: inherit"
                :href="`/DetalheSegurado/${item.id_prospect}`"
                class="font-semibold flex items-center justify-evenly w-7/12"
              >
                <div class="flex-1">
                  {{ item.nome }}
                </div>
                <div>
                  <vs-icon
                    color="primary"
                    icon-pack="feather"
                    icon="icon-external-link"
                  ></vs-icon>
                </div>
              </a>
            </div>

            <div class="vx-col p-2 flex-1 basis-3/12 flex items-center">
              {{ item.placa && `${item.placa} - ` }} {{ item.veiculoModelo }}
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{ item.brokerName }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { QUOTATION_TYPE } from '../../../../constants/quotation.type';
import { STATUS_PROPOSTA } from '../../../../utils/constants';
import functions from '../../../../utils/functions';

export default {
  props: {
    cotacoes: Array,
  },
  data() {
    return {
      QUOTATION_TYPE,
      functions,
    };
  },
  methods: {
    getVisualizationLink(item) {
      return item.id_Status === STATUS_PROPOSTA.COTACAO_ABERTA.id
        ? `/auto/cotacao/${item.id_proposta}`
        : `/auto/proposta/${item.id_proposta}`;
    },
    isEndorsement(item) {
      return !!item.endorsementId;
    },
    getDetailsUrl(item) {
      return this.isEndorsement(item)
        ? `auto/apolice/${item.policyNumber}/endosso`
        : this.getVisualizationLink(item);
    },
  },
};
</script>

<style scoped>
.vx-row {
  border-bottom: 1px solid #ddd;
}
.vx-col {
  box-sizing: border-box;
  padding: 8px;
}
.vs-button {
  margin-right: 5px;
}
</style>
